import React from 'react';
import { SkeletonMenuItem } from '@elliemae/ds-menu-items';
import { Grid } from '@elliemae/ds-grid';
import { styled } from '@elliemae/ds-system';

import { FORM_COMBOBOX_SLOTS, DSFormComboboxName } from '../../constants/index.js';

const StyledSkeletonMenuItem = styled(SkeletonMenuItem, {
  name: DSFormComboboxName,
  slot: FORM_COMBOBOX_SLOTS.SKELETON_MENU_ITEM,
  preserveLegacyDataTestId: true,
})``;

export const SkeletonContainer = ({
  instanceUid,
  getOwnerProps,
}: {
  instanceUid: string;
  getOwnerProps: () => object;
}): JSX.Element => {
  const SKELETON_AMOUNT = [0, 1, 2, 3, 4] as const;

  return (
    <Grid id={`combo-listbox-${instanceUid}`}>
      {SKELETON_AMOUNT.map((n, index) => (
        <StyledSkeletonMenuItem key={n} dsId={index.toString()} role="presentation" getOwnerProps={getOwnerProps} />
      ))}
    </Grid>
  );
};
